import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Validate driver email
 *
 * @private
 */
export const validatePhoneNumbers = createAsyncThunk<
  // Return type of the payload creator
  Record<string, boolean>,
  // First argument to the payload creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/order/validatePhoneNumbers', async (phoneNumbers, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/order/validatePhoneNumbers', {
      category: 'rpc',
      type: 'rpc/order/validatePhoneNumbers',
      phoneNumbers,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {validatePhoneNumbers}`,
      { tags: ['rpc', 'order'], info: phoneNumbers },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Validate order contact phone numbers: ${phoneNumbers.join(', ')}`,
      error,
    })
  }
})
